import styled from "styled-components";

export const FlexContainer = styled.div<{ showButtons?: boolean }>`
  width: 100%;
  height: 100%;
  background: #f8f9fa;
  padding-bottom: 2rem;
  /* padding: 0 1rem 2rem 1rem; */
  position: relative;

  & .rich-text-editor {
    background: white;
    min-height: calc(80vh - 50px);
    max-height: calc(80vh - 50px);
    overflow: auto;
  }

  @media (max-width: 1600px) {
    & .rich-text-editor {
      min-height: calc(80vh - 60px);
      max-height: calc(80vh - 60px);
    }
  }

  @media (max-width: 1366px) {
    & .rich-text-editor {
      min-height: calc(80vh - 90px);
      max-height: calc(80vh - 90px);
    }
  }

  .content-quill {
    margin: 0 2rem;
    margin-top: 2rem;
    margin: 2rem;
  }

  .ql-editor {
    background: #ededed;
    height: ${({ showButtons }) =>
      showButtons ? "calc(100vh - 320px)" : "calc(100vh - 250px)"};
  }
`;

export const MessageBlockCursor = styled.div<{
  x: number;
  y: number;
  isActive: boolean;
}>`
  width: 225px;
  height: 50px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: ${({ x, isActive }) => x !== 0 && `${x}px`};
  left: ${({ y, isActive }) => y !== 0 && `${y}px`};
  background-color: white;
  z-index: 999;
  -webkit-box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding: 1rem;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};

  transition: opacity 500ms linear;

  span {
    color: black;
    font-family: "Roboto", sans-serif;
    font-size: 1.4rem;
  }
`;

export const ButtonSubmitText = styled.button`
  width: 117px;
  height: 50px;
  background: black;
  border-radius: 5px;
  color: white;
  font-family: "Roboto";
  border-radius: 10px;
  font-size: 1.6rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0 1rem auto;
`;

export const WrapperButtons = styled.div`
  height: 70px;
  width: calc(100%);
  display: flex;
  align-items: center;
  border-bottom: 2px solid #c4c4c4;
  margin-bottom: 2rem;
  padding: 0 1rem;
  position: relative;
`;

export const NameWrapper = styled.div`
  width: 160px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Text = styled.div`
  font-family: "Roboto", sans-serif;
  color: #343a40;
  font-size: 1.4rem;
  font-weight: bold;

  @media (max-width: 1366px) {
    font-size: 1.2rem;
  }
`;

export const NameUser = styled.div`
  font-family: "Roboto", sans-serif;
  color: #663399;
  font-size: 1.4rem;
  font-weight: bold;
  text-align: right;

  @media (max-width: 1366px) {
    font-size: 1.2rem;
  }
`;
